import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './NumberedCard.module.scss';

const NumberedCard = ({ number, title, image, children, className = '' }) => {
  const classes = classNames(styles['numbered-card-revamp'], className);
  return (
    <div className={classes}>
      <div className={styles['numbered-card-revamp__number-container']}>
        <span className={styles['numbered-card-revamp__number']}>{number}</span>
      </div>

      <div className={styles['numbered-card-revamp__body']}>
        <span className={styles['numbered-card-revamp__title']}>{title}</span>
      </div>

      <div className={styles['numbered-card-revamp__content']}>{children}</div>

      <div className={styles['numbered-card-revamp__image']}>{image}</div>
    </div>
  );
};

NumberedCard.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default NumberedCard;
